import { ListCard, NetworkIcon, Skeleton, SkeletonItem } from '../../atoms';

import { S } from './RecipientCard.styled';

export const RecipientCardSkeleton = () => {
	return (
		<Skeleton>
			<S.Container $interactive={false} $selected={false}>
				<S.Content $interactive={false}>
					<S.ContentTop>
						<ListCard.Image isLoading />
						<S.TitleWrapper>
							<S.TitleContainer>
								<S.ListCardTitle>
									<SkeletonItem width={120} />
								</S.ListCardTitle>
							</S.TitleContainer>
							<ListCard.SubTitle>
								<SkeletonItem width={120} />
							</ListCard.SubTitle>
						</S.TitleWrapper>
					</S.ContentTop>
					<S.NetworkDivider orientation="horizontal" />
					<div>
						<S.Network>
							<NetworkIcon isLoading size="small" variant="circle" />
							<S.NetworkLabel variant="caption1">
								<SkeletonItem width={120} />
							</S.NetworkLabel>
						</S.Network>
						<div>
							<S.Address color="main.subtle" variant="text3">
								<SkeletonItem width={240} />
							</S.Address>
						</div>
					</div>
				</S.Content>
			</S.Container>
		</Skeleton>
	);
};
